import './ListCardComponent.scss'
import CardComponent from '../../../../components/CardComponent/CardComponent'
import CARDS_LIST_TO_VIEW from '../../../../utils/Constans';

/**
 * @function ListCardComponent Card List to view in the homePage
 * @returns {JSX.Element}
 */

const ListCardComponent = () => {
  return CARDS_LIST_TO_VIEW.map(card => {
    const { src, title, alt, tipologia, isDisabled } = card
    return (
      <div key={ title } className='col-12 col-lg-6 col-xl-3 mb-lg-3 mb-3 mb-xl-0'>
        <CardComponent src={ src } title={ title } alt={ alt } tipologia={ tipologia } isDisabled={ isDisabled } />
      </div>
    )
  })
}

ListCardComponent.defaultProps = {}

export default ListCardComponent
